/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class TreeItemLookupModel {

        constructor(
            private treeItemLookupService: services.TreeItemLookupService,
            private treeService: services.TreeService,
            private lookupEntries: Wars.Domain.Model.TreeItemLookup[],
            private processConfigId: string,
            private includeTreeSections: string,
            private isReadonly: boolean) { }

        public addNewTreeItemLookupEntry(): void {
            var treeItemLookup = this.treeItemLookupService.createTreeItemLookupEntry();
            this.lookupEntries.push(treeItemLookup);
            this.saveChanges();
        }

        public saveChanges(): void {
            this.treeItemLookupService.saveAllChanges();
        }

        public getDisplayName(treeItem: Wars.Domain.Model.TreeItem): string {
            return this.treeService.getDisplayName(treeItem);
        }

        public delete(index: number) {
            this.lookupEntries.splice(index, 1);
            this.saveChanges();
        }

        public onDragOver($event: any, $index: number): void {
            //var treeConfig = this.treeService.getTreeConfigurationItem();
        }

        public onDrop($event: any, $index: number): void {
            var treeItem = this.treeService.createTreeItemFromItemDropped();
            this.lookupEntries[$index].myTreeItem = treeItem;
            this.lookupEntries[$index].treeItem_id = treeItem.id;

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
            this.treeItemLookupService.saveAllChanges();
        }
    }
}